'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconType = undefined;

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fileTypes = [{
  expr: /(xlsx?|numbers)/i,
  color: '#70c79a',
  type: 'table'
}, {
  expr: /(png|jpe?g|tiff|gif)/i,
  color: '#40a0f4',
  type: 'image'
}, {
  expr: /(js|cs|java|md|c|py|ts)/i,
  color: '#999',
  type: 'code'
}, {
  expr: /(pptx?|key)/i,
  color: '#FF5252',
  type: 'slides'
}, {
  expr: /.*/,
  color: '#FF5252',
  type: 'text'
}];

var iconType = exports.iconType = function iconType(fileType) {
  return (0, _find2.default)(fileTypes, function (opts) {
    return fileType.match(opts.expr);
  });
};
//# sourceMappingURL=fileTypeUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/fileTypeUtil.js
// module id = 637
// module chunks = 0